import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LocationAutocompleteQueryVariables = Types.Exact<{
  searchText: Types.Scalars['String']['input'];
  country: Types.Scalars['CountryCode']['input'];
  language: Types.Scalars['LanguageCode']['input'];
  useIp?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  maxResults?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locationTypeFilter?: Types.InputMaybe<Array<Types.LocationType> | Types.LocationType>;
  exactMatchOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LocationAutocompleteQuery = { __typename?: 'Query', locationAutocomplete?: Array<{ __typename?: 'LocationAutocompleteResult', formattedName: string, location: { __typename?: 'NamedLocation', locationType: Types.LocationType, code: string, canonicalName: string, latitude: number, longitude: number, locationPrecisionKilometers: number, aliases: Array<{ __typename?: 'LocationAlias', alias: string, languageCode: string }>, ancestors: Array<{ __typename?: 'NamedLocationAncestor', locationType: Types.LocationType, code: string, canonicalName: string, latitude: number, longitude: number, locationPrecisionKilometers: number, aliases: Array<{ __typename?: 'LocationAlias', languageCode: string, alias: string }> }> }, gen2Location: { __typename?: 'Location', latitude: number, longitude: number, precisionKm: number, country: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string }, admin1?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin2?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin3?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin4?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin5?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, admin6?: { __typename?: 'LocationIdNameCodeTuple', id: string, name: string, code: string } | null, postalCode?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null, preciseLocation?: { __typename?: 'LocationIdNameTuple', id: string, name: string } | null } }> | null };


export const LocationAutocompleteDocument = gql`
    query LocationAutocomplete($searchText: String!, $country: CountryCode!, $language: LanguageCode!, $useIp: Boolean, $maxResults: Int, $locationTypeFilter: [LocationType!], $exactMatchOnly: Boolean) {
  locationAutocomplete(
    input: {searchText: $searchText, country: $country, language: $language, useIp: $useIp, maxResults: $maxResults, locationTypeFilter: $locationTypeFilter, exactMatchOnly: $exactMatchOnly}
  ) {
    location {
      locationType
      code
      canonicalName
      latitude
      longitude
      locationPrecisionKilometers
      aliases {
        alias
        languageCode
      }
      ancestors {
        locationType
        code
        canonicalName
        latitude
        longitude
        locationPrecisionKilometers
        aliases {
          languageCode
          alias
        }
      }
    }
    formattedName
    gen2Location {
      country {
        id
        name
        code
      }
      admin1 {
        id
        name
        code
      }
      admin2 {
        id
        name
        code
      }
      admin3 {
        id
        name
        code
      }
      admin4 {
        id
        name
        code
      }
      admin5 {
        id
        name
        code
      }
      admin6 {
        id
        name
        code
      }
      postalCode {
        id
        name
      }
      preciseLocation {
        id
        name
      }
      latitude
      longitude
      precisionKm
    }
  }
}
    `;

/**
 * __useLocationAutocompleteQuery__
 *
 * To run a query within a React component, call `useLocationAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationAutocompleteQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      useIp: // value for 'useIp'
 *      maxResults: // value for 'maxResults'
 *      locationTypeFilter: // value for 'locationTypeFilter'
 *      exactMatchOnly: // value for 'exactMatchOnly'
 *   },
 * });
 */
export function useLocationAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<LocationAutocompleteQuery, LocationAutocompleteQueryVariables> & ({ variables: LocationAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>(LocationAutocompleteDocument, options);
      }
export function useLocationAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>(LocationAutocompleteDocument, options);
        }
export function useLocationAutocompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>(LocationAutocompleteDocument, options);
        }
export type LocationAutocompleteQueryHookResult = ReturnType<typeof useLocationAutocompleteQuery>;
export type LocationAutocompleteLazyQueryHookResult = ReturnType<typeof useLocationAutocompleteLazyQuery>;
export type LocationAutocompleteSuspenseQueryHookResult = ReturnType<typeof useLocationAutocompleteSuspenseQuery>;
export type LocationAutocompleteQueryResult = Apollo.QueryResult<LocationAutocompleteQuery, LocationAutocompleteQueryVariables>;